"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _Header = require("./Header.styles");
var _Button = require("../../../Button");
var _Title = require("../../../Title");
var _jsxRuntime = require("react/jsx-runtime");
var Header = function Header(props) {
  var isOptionsSelected = props.isOptionsSelected,
    label = props.label,
    onSecondaryBtnClick = props.onSecondaryBtnClick,
    secondaryBtnLabel = props.secondaryBtnLabel;
  var styles = (0, _Header.useStyles)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Select__header'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Select__header__title'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.Title, {
        level: 4,
        children: label
      }), isOptionsSelected && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        id: "ccSelectHeaderClear",
        view: "link",
        color: "primary",
        size: "small",
        onClick: onSecondaryBtnClick,
        children: secondaryBtnLabel
      })]
    })
  });
};
exports.Header = Header;